import { render, staticRenderFns } from "./PosStatusPopup.vue?vue&type=template&id=934257fa&scoped=true&"
import script from "./PosStatusPopup.vue?vue&type=script&lang=js&"
export * from "./PosStatusPopup.vue?vue&type=script&lang=js&"
import style0 from "./PosStatusPopup.vue?vue&type=style&index=0&id=934257fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "934257fa",
  null
  
)

export default component.exports